import { TextVariant } from "@punks/core"
import React from "react"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"
import classes from "./TextBlock.module.css"

export interface TextBlockProps {
  text: any
  fillLine?: boolean
  variant?: TextVariant
  className?: string
}

const TextBlock = ({ text, fillLine, variant, className }: TextBlockProps) => {
  return (
    <TwRichTextField
      fillLine={fillLine}
      value={text}
      className={`${className ?? ""} ${fillLine ? classes.text : ""}`}
      variant={variant}
    />
  )
}

export default TextBlock
